import React from 'react';
import { BRAND, isBrandOV, isMarketGB } from '../../constants/main';
import { CharacteristicsStyledAC } from './AC/CharacteristicsStyled.AC';
import { CharacteristicsStyledAP } from './AP/CharacteristicsStyled.AP';
import { CharacteristicsStyledDS } from './DS/CharacteristicsStyled.DS';
import { CharacteristicsStyledOV } from './OV/CharacteristicsStyled.OV';
import { CharacteristicsStyledOV as CharacteristicsStyledOVGB } from './OV/GB/CharacteristicsStyled.OV';
import { CharacteristicsStyled } from './CharacteristicsStyled';
import { SC } from '../../styles/theme';
import { Dispatch } from 'redux';
import { IConfigurableCar } from '../../interfaces/Car';
import { connect } from 'react-redux';
import UIDuck from '../../redux/commonDucks/ui.duck';
import carDetailsDuck from '../../redux/carDetails/carDetails.duck';
import { Redux } from 'src/redux/redux.interface';

export type CharacteristicsProps = SC & ICharacteristics;

export type TechData = {
    fuel: string;
    gearbox: string;
};

export type TechnicalSpecification = {
    data: Data[];
    category: string;
    key: string;
    order: number;
};

export type Data = {
    label: string;
    value: string;
    key: string;
    order: number;
};

export type StandardFeature = {
    data: Data[];
    category: string;
    key: string;
    order: number;
};

export type Engine = {
    specs: any[];
    images: string[];
    description: string;
    id: string;
    title: string;
    prices: any[];
};

export interface ITechnicalSpecifications {
    category: string;
    key: string;
    order: number;
    data: ITechnicalSpecificationsData[];
}

export interface ITechnicalSpecificationsData {
    label: string;
    value: string;
    description?: string;
    key: string;
    order: number;
    tires?: any;
}

export interface ICharacteristics {
    characteristicsOpen?: boolean;
    dispatch?: Dispatch;
    carDetail?: IConfigurableCar;
    characteristicsRef?: React.MutableRefObject<HTMLDivElement>;
    toggleOpen?: () => void;
    isInnered?: boolean;
    isBasket?: boolean;
    isConfigurator?: boolean;
    isSummary?: boolean;
}

export interface IKeyStringAbstract {
    [key: string]: number | string;
}

const Characteristics = (props: CharacteristicsProps) => {
    if (isBrandOV)
        return isMarketGB ? <CharacteristicsStyledOVGB {...props} /> : <CharacteristicsStyledOV {...props} />;
    if (BRAND === 'AC') return <CharacteristicsStyledAC {...props} />;
    if (BRAND === 'AP') return <CharacteristicsStyledAP {...props} />;
    if (BRAND === 'DS') return <CharacteristicsStyledDS {...props} />;
    return <CharacteristicsStyled {...props} />;
};

const MapStateToProps = (state: Redux, { carDetail }: any) => {
    return {
        characteristicsOpen: UIDuck.getOwnState(state).characteristicsOpen,
        carDetail: carDetail || carDetailsDuck.getOwnState(state).currentCarDetails,
    };
};

export default connect(MapStateToProps)(Characteristics);
